import React, { useState } from 'react';
import Cross from "../SmcLife/Images/crosssign.svg";
import { Tabs, Tab } from 'react-bootstrap';
import { useEffect } from 'react';
import MaskedInput from 'react-text-mask';
import { CommaSeprator, convertIntoLakh, countTrueValuesBenefit, countTrueValuesRiders } from "./UtilityComponents/UtilityFunction";
const LifeAddons = (props) => {
    const [key, setKey] = useState('tab1');
    const [errors, setErrors] = useState({});
    const [isBtnDisabled, setBtnDisabled] = useState(true);
    const [coverageAmountDigits, setCoverageAmountDigits] = useState(5);

    const [benefitAndRiderObj, setBenefitAndRiderObj] = useState({
        IsAccidentalDeathBenefit: props.Data.IsAccidentalDeathBenefit ?? false,
        IsPremiumProtectionBenefit: props.Data.IsPremiumProtectionBenefit ?? false,
        IsPremiumWaiverBenefit: props.Data.IsPremiumWaiverBenefit ?? false,
        IsAccidentalDisabilityRider: props.Data.IsAccidentalDisabilityRider ?? false,
        IsCriticalIllnessRider: props.Data.IsCriticalIllnessRider ?? false,
        IsTerminalIllnessRider: props.Data.IsTerminalIllnessRider ?? false,
        IsPersonalAccidentRider: props.Data.IsPersonalAccidentRider ?? false,
        IsAccidentalDeathRider: props.Data.IsAccidentalDeathRider ?? false,
        IsHospitalCareRider: props.Data.IsHospitalCareRider ?? false
    });

    const [riderSumInsured, setRiderSumInsured] = useState({
        RiderAccidentalDisabilitySumInsured: props.Data.RiderAccidentalDisabilitySumInsured,
        RiderCriticalIllnessSumInsured: props.Data.RiderCriticalIllnessSumInsured,
        RiderTerminalIllnessSumInsured: props.Data.RiderTerminalIllnessSumInsured,
        RiderPersonalAccidentSumInsured: props.Data.RiderPersonalAccidentSumInsured,
        RiderAccidentalDeathSumInsured: props.Data.RiderAccidentalDeathSumInsured,
        RiderHospitalCareSumInsured: props.Data.RiderHospitalCareSumInsured

    });

    const rupeeSymbol = '₹';


    useEffect(() => {
        //console.log("call fun", compareObjValuesFromPrev());
        if (props?.Tab == "Benefits") {
            let result = compareObjValuesFromPrev(benefitAndRiderObj);
            setBtnDisabled(result);
        } else {
            let result = compareRidersPrevValues();
            setBtnDisabled(result);
        }

    }, [benefitAndRiderObj, riderSumInsured, props.Data]);

    const compareObjValuesFromPrev = (obj) => {
        return !Object.entries(obj).some(([key, value]) => value !== props?.Data[key]);
    }

    const compareRidersPrevValues = () => {
        const isRiderSumInsuredSame= !Object.entries(riderSumInsured).some(([key, value]) => value !== props.Data[key]);
        const isBenefitObjSame = !Object.entries(benefitAndRiderObj).some(([key, value]) => value !== props.Data[key]);
        return isRiderSumInsuredSame && isBenefitObjSame;
    }

    useEffect(() => {

        const coverageAmtDigits = props.CoverageAmount.toString();
        setCoverageAmountDigits(coverageAmtDigits.replace(/[^\d]/g, '').length, "coverageAmtDigits")
        if (props.Tab == "Benefits") {
            setKey('tab1');
        }
        else {
            setKey('tab2');
        }
    }, []);

    const handleChange = (e) => {
        const { name, checked } = e.target;
        setBenefitAndRiderObj({ ...benefitAndRiderObj, [name]: checked });
    }

 /*   const handleRiderSumInsured = (e) => {

        const { name, value } = e.target;
        const numericValue = value.replace('₹', '');
        setRiderSumInsured({ ...riderSumInsured, [name]: numericValue });
        validation();
    }*/

    const handleRiderSumInsured = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/[^\d.]/g, ""); // remove non-numeric characters except dot
        const amount = parseFloat(numericValue);
        const updatedRiders = { ...riderSumInsured, [name]: numericValue };

        setRiderSumInsured(updatedRiders);

        // Validate on the fly
        let error = { ...errors }; // keep current errors
        const isActive = benefitAndRiderObj[`Is${name.replace("Rider", "").replace("SumInsured", "Rider")}`]; // checks related rider is selected
        
        if (isActive) {
            if (!numericValue) {
                error[name] = "Enter sum insured value";
            } else if (amount > props.CoverageAmount) {
                error[name] = "Amount cannot exceed the given range";
            } else if (amount < 500) {
                error[name] = "Amount cannot be less than the given range";
            } else {
                delete error[name]; // remove error if valid
            }
            setErrors(error);
        }
    };


    const mask = [rupeeSymbol];
    for (let i = 0; i < coverageAmountDigits; i++) {
        mask.push(/\d/);
        //mask[0] = (/[1-9]/);
    }


    const reCalculate = () => {
       
        let error = {};
        let goto = true;
        const { IsAccidentalDeathBenefit, IsPremiumProtectionBenefit, IsPremiumWaiverBenefit, IsAccidentalDisabilityRider, IsCriticalIllnessRider, IsTerminalIllnessRider, IsPersonalAccidentRider, IsAccidentalDeathRider, IsHospitalCareRider } = benefitAndRiderObj;
        const { RiderAccidentalDisabilitySumInsured, RiderCriticalIllnessSumInsured, RiderTerminalIllnessSumInsured, RiderPersonalAccidentSumInsured, RiderAccidentalDeathSumInsured, RiderHospitalCareSumInsured } = riderSumInsured;

        //console.log(IsCriticalIllnessRider, )
        if (IsAccidentalDisabilityRider) {
            if (!RiderAccidentalDisabilitySumInsured || RiderAccidentalDisabilitySumInsured === "") {
                goto = false;
                error["RiderAccidentalDisabilitySumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderAccidentalDisabilitySumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderAccidentalDisabilitySumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderAccidentalDisabilitySumInsured) < 500) {
                goto = false;
                error["RiderAccidentalDisabilitySumInsured"] = "Amount cannot be less than the given range";
            }
        }

        if (IsCriticalIllnessRider) {
            if (!RiderCriticalIllnessSumInsured || RiderCriticalIllnessSumInsured === "") {
                goto = false;
                error["RiderCriticalIllnessSumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderCriticalIllnessSumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderCriticalIllnessSumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderCriticalIllnessSumInsured) < 500) {
                goto = false;
                error["CriticalillnessRiderSumInsured"] = "Amount cannot be less than the given range";
            }
        }

        if (IsTerminalIllnessRider) {
            if (!RiderTerminalIllnessSumInsured || RiderTerminalIllnessSumInsured === "") {
                goto = false;
                error["RiderTerminalIllnessSumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderTerminalIllnessSumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderTerminalIllnessSumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderTerminalIllnessSumInsured) < 500) {
                goto = false;
                error["RiderTerminalIllnessSumInsured"] = "Amount cannot be less than the given range";
            }
        }

        if (IsPersonalAccidentRider) {
            if (!RiderPersonalAccidentSumInsured || RiderPersonalAccidentSumInsured === "") {
                goto = false;
                error["RiderPersonalAccidentSumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderPersonalAccidentSumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderPersonalAccidentSumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderPersonalAccidentSumInsured) < 500) {
                goto = false;
                error["RiderPersonalAccidentSumInsured"] = "Amount cannot be less than the given range";
            }
        }

        if (IsAccidentalDeathRider) {
            if (!RiderAccidentalDeathSumInsured || RiderAccidentalDeathSumInsured === "") {
                goto = false;
                error["RiderAccidentalDeathSumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderAccidentalDeathSumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderAccidentalDeathSumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderAccidentalDeathSumInsured) < 500) {
                goto = false;
                error["RiderAccidentalDeathSumInsured"] = "Amount cannot be less than the given range";
            }
        }

        if (IsHospitalCareRider) {
            if (!RiderHospitalCareSumInsured || RiderHospitalCareSumInsured === "") {
                goto = false;
                error["RiderHospitalCareSumInsured"] = "Enter sum insured value";
            } else if (parseFloat(RiderHospitalCareSumInsured) > props.CoverageAmount) {
                goto = false;
                error["RiderHospitalCareSumInsured"] = "Amount cannot exceed the given range";
            }
            else if (parseFloat(RiderHospitalCareSumInsured) < 500) {
                goto = false;
                error["RiderHospitalCareSumInsured"] = "Amount cannot be less than the given range";
            }
        }

        setErrors(error);
        
        if (goto) {

            let data = {
                ridersAndBenefit: benefitAndRiderObj,
                riderSumInsured
            }
            props.CallQuoteWithRiderAddons(data);
            props.IsClose()
            sessionStorage.setItem("benefitCount", countTrueValuesBenefit(benefitAndRiderObj))
            sessionStorage.setItem("riderCount", countTrueValuesRiders(benefitAndRiderObj))
            props.CountBenefit(countTrueValuesBenefit(benefitAndRiderObj));
            props.CountRiders(countTrueValuesRiders(benefitAndRiderObj));
        }
    }
    
    return (
        <div className="SmcEditDetailCard">
            <div className="space">
                <div className="container">
                    <div className="EditDetailShadow">

                        <div className="DetailBoxCard BenefitsAndRidersPopUp">
                            <div className="CrossSign" onClick={props.IsClose}>
                                <img src={Cross} alt="Benefits&Riders" />
                            </div>
                            <Tabs
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => setKey(k)}
                            >
                                {props.Tab === "Benefits" && <Tab eventKey="tab1" title="Benefits">
                                    <ul>
                                        <li className="CompareCheck">
                                            <label>
                                                <input id="IsAccidentalDeathBenifitRider" type="checkbox" name="IsAccidentalDeathBenefit" checked={benefitAndRiderObj.IsAccidentalDeathBenefit} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Accidental Death Benefit</b>
                                            </label>
                                        </li>
                                        <li className="CompareCheck">
                                            <label>
                                                <input id="ISReturnofPremiumRider" type="checkbox" name="IsPremiumProtectionBenefit" checked={benefitAndRiderObj.IsPremiumProtectionBenefit} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Return of Premium Benefit</b>
                                            </label>
                                        </li>
                                        <li className="CompareCheck">
                                            <label>
                                                <input id="IsWaiverOfPremiumRider" type="checkbox" name="IsPremiumWaiverBenefit" checked={benefitAndRiderObj.IsPremiumWaiverBenefit} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Waiver of Premium Benefit</b>
                                            </label>
                                        </li>
                                    </ul>

                                </Tab>}
                                {props.Tab === "Riders" &&
                                    <Tab eventKey="tab2" title="Riders">
                                    <ul>
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsAccidentalDisabilityRider" checked={benefitAndRiderObj.IsAccidentalDisabilityRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Accidental Disability Rider</b>
                                            </label>
                                            {benefitAndRiderObj.IsAccidentalDisabilityRider &&
                                                <div className="user-input-wrp">

                                                    <MaskedInput
                                                        className="inputText riders_input_amt"
                                                        mask={mask}
                                                        guide={false}
                                                        required
                                                        autoFocus
                                                        showMask={false} name="RiderAccidentalDisabilitySumInsured" onChange={handleRiderSumInsured} value={riderSumInsured.RiderAccidentalDisabilitySumInsured== 0 ? "" : CommaSeprator(riderSumInsured.RiderAccidentalDisabilitySumInsured)} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderAccidentalDisabilitySumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>
                                                </div>
                                            }

                                        </li>
                                        {(benefitAndRiderObj.IsAccidentalDisabilityRider && errors.RiderAccidentalDisabilitySumInsured) && <p className="text-danger riders-error-p">{errors.RiderAccidentalDisabilitySumInsured}</p>}
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsCriticalIllnessRider" checked={benefitAndRiderObj.IsCriticalIllnessRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Critical Illness Rider</b>
                                            </label>
                                            {benefitAndRiderObj.IsCriticalIllnessRider &&
                                                <div className="user-input-wrp">

                                                    <MaskedInput
                                                        className="inputText riders_input_amt"
                                                        mask={mask}
                                                        guide={false}
                                                        required
                                                        autoFocus
                                                        showMask={false} name="RiderCriticalIllnessSumInsured" value={riderSumInsured.RiderCriticalIllnessSumInsured == 0 ? "" : CommaSeprator(riderSumInsured.RiderCriticalIllnessSumInsured)} onChange={handleRiderSumInsured} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderCriticalIllnessSumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>
                                                </div>
                                            }
                                        </li>
                                        {(benefitAndRiderObj.IsCriticalIllnessRider && errors.RiderCriticalIllnessSumInsured) && <p className="text-danger riders-error-p">{errors.RiderCriticalIllnessSumInsured}</p>}
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsTerminalIllnessRider" checked={benefitAndRiderObj.IsTerminalIllnessRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Cancer Care Rider</b>
                                            </label>
                                            {benefitAndRiderObj.IsTerminalIllnessRider &&
                                                <div className="user-input-wrp">

                                                    <MaskedInput
                                                        className="inputText riders_input_amt"
                                                        mask={mask}
                                                        guide={false}
                                                        required
                                                        autoFocus
                                                        showMask={false} name="RiderTerminalIllnessSumInsured" value={riderSumInsured.RiderTerminalIllnessSumInsured == 0 ? "" : CommaSeprator(riderSumInsured.RiderTerminalIllnessSumInsured)} onChange={handleRiderSumInsured} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderTerminalIllnessSumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>
                                                </div>}
                                        </li>
                                            {(benefitAndRiderObj.IsTerminalIllnessRider && errors.RiderTerminalIllnessSumInsured) && <p className="text-danger riders-error-p">{errors.RiderTerminalIllnessSumInsured}</p>}
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsPersonalAccidentRider" checked={benefitAndRiderObj.IsPersonalAccidentRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Personal Accident Cover</b>
                                            </label>
                                            {benefitAndRiderObj.IsPersonalAccidentRider &&
                                                <div className="user-input-wrp">
                                                    <MaskedInput
                                                        className="inputText riders_input_amt"
                                                        mask={mask}
                                                        guide={false}
                                                        required
                                                        autoFocus
                                                        showMask={false} name="RiderPersonalAccidentSumInsured" value={riderSumInsured.RiderPersonalAccidentSumInsured == 0 ? "" : CommaSeprator(riderSumInsured.RiderPersonalAccidentSumInsured)} onChange={handleRiderSumInsured} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderPersonalAccidentSumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>
                                                </div>
                                            }
                                        </li>
                                        {benefitAndRiderObj.IsPersonalAccidentRider && errors.RiderPersonalAccidentSumInsured && <p className="text-danger riders-error-p">{errors.RiderPersonalAccidentSumInsured}</p>}
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsAccidentalDeathRider" checked={benefitAndRiderObj.IsAccidentalDeathRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Accidental Death Cover</b>
                                            </label>
                                            {benefitAndRiderObj.IsAccidentalDeathRider &&
                                                <div className="user-input-wrp">
                                                    <MaskedInput
                                                        className="inputText riders_input_amt"
                                                        mask={mask}
                                                        guide={false}
                                                        autoFocus
                                                        required
                                                        showMask={false} name="RiderAccidentalDeathSumInsured" value={riderSumInsured.RiderAccidentalDeathSumInsured == 0 ? "" : CommaSeprator(riderSumInsured.RiderAccidentalDeathSumInsured)} onChange={handleRiderSumInsured} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderAccidentalDeathSumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>
                                                </div>}
                                        </li>
                                        {benefitAndRiderObj.IsAccidentalDeathRider && errors.RiderAccidentalDeathSumInsured && <p className="text-danger riders-error-p">{errors.RiderAccidentalDeathSumInsured}</p>}
                                        <li className="CompareCheck riders_compare_check">
                                            <label>
                                                <input id="0" type="checkbox" name="IsHospitalCareRider" checked={benefitAndRiderObj.IsHospitalCareRider} onChange={handleChange} />
                                                <span className="checkmarkCom"></span>
                                                <b>Hospital Care Rider</b>
                                            </label>
                                            {benefitAndRiderObj.IsHospitalCareRider &&
                                                <div className="user-input-wrp"><MaskedInput
                                                    className="inputText riders_input_amt"
                                                    mask={mask}
                                                    guide={false}
                                                    autoFocus
                                                    required
                                                    showMask={false} name="RiderHospitalCareSumInsured" value={riderSumInsured.RiderHospitalCareSumInsured == 0 ? "" : CommaSeprator(riderSumInsured.RiderHospitalCareSumInsured)} onChange={handleRiderSumInsured} />
                                                    <span className="floating-label floating_label_riders">Enter Amount</span>
                                                    <p className="convert_lakhBox">{convertIntoLakh(riderSumInsured.RiderHospitalCareSumInsured)}</p>
                                                    <p>Amount between ₹500- ₹{convertIntoLakh(props.CoverageAmount)}</p>

                                                </div>}
                                        </li>
                                        {benefitAndRiderObj.IsHospitalCareRider && errors.RiderHospitalCareSumInsured && <p className="text-danger riders-error-p">{errors.RiderHospitalCareSumInsured}</p>}
                                    </ul>
                                </Tab>}
                            </Tabs>
                            <div className="">
                                <div className="modal-footer text-center CalculatePrmBtn">
                                    <button className="AddonsBTN" disabled={isBtnDisabled} onClick={reCalculate}>Re-Calculate</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LifeAddons;



